<template>
  <v-app-bar
    :clipped-left="$vuetify.breakpoint.lgAndUp"
    app
    color="white-flat-border-bottom"
    flat
    light
  >
    <v-app-bar-nav-icon @click.stop="toggleDrawer"/>
    <v-toolbar-title style="width: 300px" class="ml-0 pl-4">
      <span class="hidden-sm-and-down text-h6">Controle de Frota</span>
    </v-toolbar-title>
    <v-spacer/>
    <v-btn icon>
      <v-icon>mdi-apps</v-icon>
    </v-btn>
    <v-btn icon>
      <v-icon>mdi-bell</v-icon>
    </v-btn>
    <v-menu offset-y>
    <template v-slot:activator="{ on }">
      <v-btn icon v-on="on">
        <v-icon>mdi-account</v-icon>
      </v-btn>
    </template>
    <v-list :elevation="1">
      <template v-for="(item, index) in items">
        <v-list-item
          v-if="item.link"
          :key="index"
          :to="item.link"
          link
        >
          <v-list-item-icon>
            <v-icon v-text="item.icon"></v-icon>
          </v-list-item-icon>
          <v-list-item-title>{{ item.title }}</v-list-item-title>
        </v-list-item>
        <v-divider
          class="ma-0"
          v-else-if="item.divider"
          :key="index"
        ></v-divider>
        <v-list-item
          v-else
          :key="index"
          @click="logoutService"
          >
          <v-list-item-icon>
             <v-icon v-text="item.icon"></v-icon>
          </v-list-item-icon>
          <v-list-item-title>{{ item.title }}</v-list-item-title>
        </v-list-item>
      </template>
    </v-list>
  </v-menu>
  </v-app-bar>
</template>

<script>
import tokenServices from '@/services/util/token';
import { mapActions } from 'vuex';

export default {
  data: () => ({
    items: [
      {
        title: 'Meus Dados',
        icon: 'mdi-account',
        link: 'me',
      },
      {
        divider: true,
      },
      {
        icon: 'mdi-logout',
        title: 'Sair',
      },
    ],
  }),
  methods: {
    ...mapActions('app', ['toggleDrawer']),
    ...mapActions('auth', ['logout']),
    logoutService() {
      this.logout().then(() => {
        tokenServices.setToken(null);
        this.$router.push('/login');
      });
    },
  },
};
</script>

<style lang="scss"></style>
